export default function install (Vue) {
  const that = this

  if (install.installed) return
  install.installed = true

  Object.defineProperty(Vue.prototype, '$smsApi', {
    get () {
      return that.instance
    }
  })
}



// WEBPACK FOOTER //
// ./src/apis/sms-api/install.js